import React, {Component} from 'react';
import io from 'socket.io-client';
import EtaStatusBar from './EtaStatusBar';
import EtaMap from './EtaMap';
import './EtaSharingApp.css';
import EtaInfo from './EtaInfo';
import Loader from "./Loader";

class EtaSharingApp extends Component {
    constructor(props) {
        super(props);

        let metaThemeColor = document.querySelector("meta[name=theme-color]");
        let host;
        let themeColor;
        switch (window.location.hostname) {
            case "eta.flitsmeister.nl":
                host = "flitsmeister";
                themeColor = '#007FE8';
                break;
            case "eta.touringmobilisapp.com":
                host = "touring";
                themeColor = '#131D5E';
                break;
            default:
                host = "flitsmeister";
                themeColor = '#007FE8';
                break;
        }
        metaThemeColor.setAttribute("content", themeColor);

        this.state = {
            host,
            themeColor,
            status: null,
            eta: null,
            id: null,
            dataFetched: false,
            landscape: false,
            showContent: false,
            connectionLost: false
        };

        this.processInitFetch = this.processInitFetch.bind(this);
        this.setUpSocket = this.setUpSocket.bind(this);

        setInterval(() => {
            try {
                this.checkIfDataIsFresh(this.state.status.etaStatus, this.state.eta.datetime);
            } catch (e) {
                // do nothing
            }
        }, 5000);
    }

    componentDidMount() {
        window.mobilecheck = function () {
            let check = false;
            (function (a) {
                // eslint-disable-next-line
                if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
            })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        };

        if (window.mobilecheck()) {
            let landscape = window.matchMedia("(orientation: landscape)").matches;
            this.setState({
                landscape
            });

            window.onresize = () => {
                let landscape = window.matchMedia("(orientation: landscape)").matches;
                this.setState({
                    landscape
                });
            }
        }

        const id = window.location.pathname.substr(1);
        if (id !== '') {
            this.setState({id});

            return fetch(`/init/${id}`)
                .then((response) => response.json())
                .then((responseJson) => {
                    this.processInitFetch(responseJson);
                }).catch((error) => {
                    this.setState({
                        connectionFailure: true
                    });
                    console.error(error);
                })
        }

        this.setState({
            noParameterInUrl: true
        });
    }

    setUpSocket() {
        const socket = io(window.location.hostname, {path: '/ws', transports: ['websocket']});

        socket.on('connect', function () {
            socket.emit('room', this.state.id);
        }.bind(this));

        socket.on('etaToClient', function (datetime, lat, lng, eta, currentSpeed) {
            if (currentSpeed === null || currentSpeed === undefined)
                currentSpeed = -1;

            this.setState({
                eta: {
                    datetime,
                    lat,
                    lng,
                    eta,
                    currentSpeed
                },
                connectionLost: false
            });
        }.bind(this));

        socket.on('statusToClient', function (status) {
            let stateStatus = this.state.status;
            stateStatus.etaStatus = status;

            if (status !== "driving") {
                this.setState({
                    statusHasBeenDriving: true
                })
            }
            this.setState({
                status: stateStatus,
                connectionLost: false
            });
        }.bind(this));
    }

    processInitFetch(responseObject) {
        if (responseObject.hasOwnProperty('error')) {
            this.setState({
                status: {
                    etaStatus: 'id-error'
                },
                dataFetched: true
            });
        } else {
            this.setState({
                status: {
                    etaStatus: responseObject.status,
                    destinationLat: responseObject.des_lat,
                    destinationLng: responseObject.des_lng,
                    eta: responseObject.eta,
                    lat: responseObject.lat,
                    lng: responseObject.lng,
                    datetime: responseObject.datetime
                },
                dataFetched: true
            });

            if (responseObject.status === "driving") {
                this.setState({
                    statusHasBeenDriving: true
                });
                this.checkIfDataIsFresh(responseObject.status, responseObject.datetime);
            }

            this.setUpSocket();
        }
    }

    setShowContent = () => {
        this.setState({
            showContent: true
        })
    };

    checkIfDataIsFresh = (status, datetime) => {
        if (status === "driving") {
            let date = new Date();
            date.setSeconds(date.getSeconds() - 10);
            if (new Date(datetime) < date) {
                this.setState({
                    connectionLost: true
                });
            }
        }
    };


    render() {
        let etaMap;
        let statusBar;
        let loader;

        if (this.state.dataFetched) {
            etaMap = <EtaMap status={this.state.status} eta={this.state.eta} landscape={this.state.landscape}
                             showContent={this.setShowContent} statusHasBeenDriving={this.state.statusHasBeenDriving} themeColor={this.state.themeColor}/>;
            if (this.state.showContent) {
                loader = null;
            } else {
                loader = <Loader host={this.state.host} themeColor={this.state.themeColor}/>;
            }

            statusBar = <EtaStatusBar status={this.state.status.etaStatus} landscape={this.state.landscape}
                                      connectionLost={this.state.connectionLost}/>;

        } else if (this.state.connectionFailure) {
            statusBar = <EtaStatusBar status='connection-failure' landscape={this.state.landscape}
                                      connectionLost={this.state.connectionLost}/>;
        } else if (this.state.noParameterInUrl) {
            statusBar = <EtaStatusBar status='no-parameter' landscape={this.state.landscape}
                                      connectionLost={this.state.connectionLost}/>
        } else {
            loader = <Loader host={this.state.host} themeColor={this.state.themeColor}/>
        }


        return (
            <div className={"EtaSharingApp " + this.state.host}>
                {statusBar}
                {etaMap}
                {loader}
                <EtaInfo landscape={this.state.landscape} host={this.state.host}/>
            </div>
        );
    }
}


export default EtaSharingApp;
